/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_no_orders_found = /** @type {(inputs: {}) => string} */ () => {
	return `Nebyly nalezeny žádné objednávky.`
};

const da_no_orders_found = /** @type {(inputs: {}) => string} */ () => {
	return `Ingen ordrer fundet.`
};

const de_no_orders_found = /** @type {(inputs: {}) => string} */ () => {
	return `Keine Bestellungen gefunden.`
};

const en_no_orders_found = /** @type {(inputs: {}) => string} */ () => {
	return `No orders found.`
};

const es_no_orders_found = /** @type {(inputs: {}) => string} */ () => {
	return `No se encontraron pedidos.`
};

const fr_no_orders_found = /** @type {(inputs: {}) => string} */ () => {
	return `Aucune commande n'a été trouvée.`
};

const hu_no_orders_found = /** @type {(inputs: {}) => string} */ () => {
	return `Nem találhatók rendelések.`
};

const it_no_orders_found = /** @type {(inputs: {}) => string} */ () => {
	return `Nessun ordine trovato.`
};

const nl_no_orders_found = /** @type {(inputs: {}) => string} */ () => {
	return `Geen bestellingen gevonden.`
};

const pl_no_orders_found = /** @type {(inputs: {}) => string} */ () => {
	return `Nie znaleziono zamówień.`
};

const pt_no_orders_found = /** @type {(inputs: {}) => string} */ () => {
	return `Nenhum pedido encontrado.`
};

const sv_no_orders_found = /** @type {(inputs: {}) => string} */ () => {
	return `Inga beställningar hittades.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const no_orders_found = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.no_orders_found(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("no_orders_found", locale)
	if (locale === "cs") return cs_no_orders_found(inputs)
	if (locale === "da") return da_no_orders_found(inputs)
	if (locale === "de") return de_no_orders_found(inputs)
	if (locale === "en") return en_no_orders_found(inputs)
	if (locale === "es") return es_no_orders_found(inputs)
	if (locale === "fr") return fr_no_orders_found(inputs)
	if (locale === "hu") return hu_no_orders_found(inputs)
	if (locale === "it") return it_no_orders_found(inputs)
	if (locale === "nl") return nl_no_orders_found(inputs)
	if (locale === "pl") return pl_no_orders_found(inputs)
	if (locale === "pt") return pt_no_orders_found(inputs)
	return sv_no_orders_found(inputs)
};